import { render, staticRenderFns } from "./ListStockMovementPage.vue?vue&type=template&id=015cc78c"
import script from "./ListStockMovementPage.vue?vue&type=script&lang=js"
export * from "./ListStockMovementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports